import { render, staticRenderFns } from "./NewsCategoryEdit.vue?vue&type=template&id=3213eb04&scoped=true&"
import script from "./NewsCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213eb04",
  null
  
)

export default component.exports